// extracted by mini-css-extract-plugin
module.exports = {"c1i93qbu":"c1i93qbu","t1lmvg8l":"t1lmvg8l"};